<template>
  <div class="settings_right">
    <div class="content-header">
      <div class="content-header-left">
        <div class="search">
          <vs-input :key="'searchtxt'"
            icon-pack="feather"
            icon="icon-search"
            v-model="searchtxt"
            placeholder="Search by Name"
            class="is-label-placeholder"
          />
        </div>
      </div>
      <div class="content-header-right">
        <!--
        <vs-dropdown  vs-custom-content vs-trigger-click>
          <vs-button
            color="primary"
            class="filter-btn"
            type="border"
            icon-pack="feather"
            icon="icon-chevron-down"
            icon-after
          >
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
          </vs-button>
          <vs-dropdown-menu ref="filter_menu" class="filters-content">

            <div class="filters-form-fileds">
              <div class="form-container">
                <div class="vx-row">

                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select Type</label>
                    
                    <multiselect v-model="selected_typeids" :options="all_formTypes" :multiple="true" :hideSelected="true"
                      :close-on-select="false" :clear-on-select="false" :select-label="''" :preserve-search="true"
                      placeholder="Select types" label="name" track-by="name" :preselect-first="false">
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                          options selected</span>
                      </template>
                    </multiselect>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select Status</label>
                    
                    <multiselect v-model="selected_statusids" :options="all_statusids" :multiple="true" :hideSelected="true"
                      :close-on-select="false" :clear-on-select="false" :select-label="''" :preserve-search="true"
                      placeholder="Select Status" label="name" track-by="name" :preselect-first="false">
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                          options selected</span>
                      </template>
                    </multiselect>
                  </div>

                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Created Date</label>
                    <date-range-picker
                      :autoApply="autoApply"
                      :ranges="false"
                      v-model="selected_createdDateRange"
                    ></date-range-picker>
                  </div>
                 </div>
                   
                   
     
              </div>
            </div>
            <div class="filters-status">
              <div class="left-buttons">

              </div>
              <div class="right-buttons">
                <vs-button color="success" class="save" type="filled" v-on:click="set_filter()">Apply</vs-button>
                <vs-button color="dark" class="cancel" type="filled" v-on:click="clear_filter($event)">Clear
                </vs-button>
              </div>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>
        -->
        <!-- end -->
        <vs-button
          type="border"
          v-if="getUserRoleId == 1"
          class="light-blue-btn"
          @click="createNew(true)"
          >Add New Role<span>
            <img
              class="add-user-icon ml-2"
              src="@/assets/images/main/add-user.svg"
            />
          </span>
        </vs-button>
      </div>
    </div>
    <!--- You haven\'t  created any User Roles yet. Create a User Roles to start using the ImmiBox ---->
    <NoDataFound
      ref="NoDataFoundRef"
      v-if="list.length == 0"
      :content="callFromSerch ? '' : ''"
      :heading="callFromSerch ? 'No Results Found' : 'No Case Types Found'"
      type="User Roles"
    />

    <div class="accordian-table" v-if="list.length > 0">
      <vs-table :data="list" :no-data-text="'No data found..!'">
        <template slot="thead" v-if="list.length > 0">
          <vs-th>
            <a
              @click="sortMe('name')"
              v-bind:class="{
                sort_ascending: sortKeys['name'] == 1,
                sort_descending: sortKeys['name'] != 1,
              }"
            >
              Name
            </a>
          </vs-th>
          <!--
          <vs-th>Type</vs-th>
          <vs-th>

          <a @click="sortMe('createdOn')"  v-bind:class="{'sort_ascending':sortKeys['createdOn']==1, 'sort_descending':sortKeys['createdOn']!=1}" >
             Created On
              </a>
          
          </vs-th>
           <vs-th>

          <a @click="sortMe('updatedOn')"  v-bind:class="{'sort_ascending':sortKeys['updatedOn']==1, 'sort_descending':sortKeys['updatedOn']!=1}" >
             Updated On
              </a>
          
          </vs-th>
           <vs-th>Status</vs-th> -->
          <vs-th class="actions">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <template v-for="(tr, indextr) in data">
            <vs-tr
              v-if="allowed_roles.indexOf(tr.id) > -1"
              :data="tr"
              :key="indextr"
            >
              <vs-td :data="tr.username">
                {{ tr.name }}
              </vs-td>
              <!--<vs-td>
             {{ checkProperty( tr,'type')}}
            </vs-td>
            <vs-td>
             {{tr.createdOn | formatDate}}
            </vs-td>
            
            <vs-td>
             {{tr.updatedOn | formatDate}}
            </vs-td>

           
            <vs-td >
              <span class="statusspan " :class="{'status_pending':tr.statusId==1,'status_active':tr.statusId==2,'status_rejected':tr.statusId==3,'status_rejected':tr.statusId==4}" >
              {{checkProperty(tr ,"statusDetails" ,'name')}}
              </span>
            </vs-td> -->

              <vs-td :data="tr.statusId">
                <vs-dropdown class="msg_dropdown_icon" :vs-trigger-click="true">
                  <a class="a-icon" href.prevent
                    ><more-vertical-icon
                      size="1.5x"
                      class="custom-class"
                    ></more-vertical-icon
                  ></a>
                  <vs-dropdown-menu class="loginx msg_dropdown">
                    <vs-dropdown-item>
                      <a
                        style="cursor: pionter; padding: 3px 10px"
                        href.prevent
                        @click="editMe(tr)"
                        >Edit</a
                      >
                    </vs-dropdown-item>

                    <!-- <p style="cursor:pionter" @click="deleteConform(tr)" >Delete</p> -->
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>
            </vs-tr>
          </template>
        </template>
      </vs-table>
      <paginate
        v-if="list.length > 0"
        v-model="page"
        :page-count="totalpages"
        :page-range="3"
        :margin-pages="2"
        :click-handler="pageNate"
        prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
        next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
        :prev-text="'<i></i>'"
        :next-text="'<i></i>'"
        :container-class="'pagination vs-pagination--nav'"
        :page-class="'page-item'"
      ></paginate>
    </div>

    <vs-popup
      class="holamundo main-popup"
      :title="edit ? 'Edit Role ' : 'Add New Role'"
      v-if="addPopup"
      :active.sync="addPopup"
    >
      <form>
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="form_group">
                <label for class="form_label">Name<em>*</em></label>
                <vs-input :key="'UserRole'"
                  @click="formerrors.msg = ''"
                  v-model="newform.name"
                  name="UserRole"
                  v-validate="'required'"
                  class="w-full"
                  data-vv-as="Name"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('UserRole')"
                  >{{ errors.first("UserRole") }}</span
                >
              </div>
            </div>
          </div>

          <div
            class="text-danger text-sm formerrors"
            v-show="formerrors.msg"
            @click="formerrors.msg = ''"
          >
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formerrors.msg }}</vs-alert
            >
          </div>
        </div>
        <div class="popup-footer">
          <vs-button
            color="dark"
            @click="
              edit = false;
              createNew(false);
            "
            class="cancel"
            type="filled"
            >Cancel</vs-button
          >
          <vs-button
            color="success"
            :disabled="validateForm || creatingRole"
            class="save"
            v-if="edit"
            @click="updateMasetrRole()"
            type="filled"
            >Update</vs-button
          >
          <vs-button
            color="success"
            :disabled="validateForm || creatingRole"
            class="save"
            v-else
            @click="createformandLetter()"
            type="filled"
            >Save</vs-button
          >
        </div>
      </form>
    </vs-popup>

    <vs-popup
      class="holamundo main-popup"
      title="Delete form and letters"
      :active.sync="approveConformpopUp"
    >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
            {{ actionText }}
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="approveConformpopUp = false"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="save"
          type="filled"
          @click="deleteformandLetter()"
          >Delete</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import Datepicker from "vuejs-datepicker-inv";
import Paginate from "vuejs-paginate";

import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import _ from "lodash";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import moment from "moment";
import PhoneMaskInput from "vue-phone-mask-input";
import JQuery from "jquery";
import { TheMask } from "vue-the-mask";

import FileUpload from "vue-upload-component/src";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { MoreVerticalIcon } from "vue-feather-icons";
import NoDataFound from "@/views/common/noData.vue";
export default {
  computed: {
    validateForm() {
      if (
        this.newform.name &&
        this.newform.name.trim() != "" &&
        this.newform.category &&
        this.newform.category == "user_roles"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  components: {
    NoDataFound,
    DateRangePicker,
    VuePhoneNumberInput,
    Datepicker,
    Paginate,
    FileUpload,
    FormWizard,
    TabContent,
    PhoneMaskInput,
    TheMask,
    MoreVerticalIcon,
    creatingRole: false,
  },

  data: () => ({
    callFromSerch: false,
    selected_createdDateRange: ["", ""],
    autoApply: "",
    value: [],
    all_formTypes: [
      { name: "Form", id: "Form" },
      { name: "Letter", id: "Letter" },
    ],

    selectedItem: null,
    selectedStatus: 2,
    actionText: "Do you want to Delete?",
    formerrors: {
      msg: "",
    },
    date: null,
    approveConformpopUp: false,

    newform: { name: "", category: "user_roles" },
    list: [],
    addPopup: false,
    NewPetition: false,

    searchtxt: "",
    query: [],
    country_code: 231,
    all_statusids: [],
    selected_statusids: [],
    final_selected_statusids: [],
    filter_roleIds: [],
    final_filter_roleIds: [1, 2, 3, 4, 5, 8, 9, 10, 11, 12],

    allowed_roles: [],
    seleted_states: [],
    final_selected_states: [],
    locations: [],
    // locationIds
    final_selected_typesids: [],
    selected_typeids: [],

    date: "",
    date_range: [],
    page: 1,
    perpage: 25,
    totalpages: 0,

    switch2: true,
    users_status: {},
    edit: false,
    sortKeys: {},
    sortKey: {},
  }),
  watch: {
    searchtxt: function (value) {
      this.getList(true);
    },
  },
  methods: {
    sortMe(sort_key = "") {
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        // this.sortKey[sort_key] = this.sortKeys[sort_key]
        this.sortKey = { path: sort_key, order: this.sortKeys[sort_key] };

        localStorage.setItem("userroles_sort_key", sort_key);
        localStorage.setItem("userroles_sort_value", this.sortKey[sort_key]);
        this.getList();
      }
    },
    editMe(item) {
      this.edit = true;
      this.selectedItem = item;
      Object.assign(this.formerrors, { msg: "" });

      this.newform = { name: this.selectedItem.name, category: "user_roles" };

      this.addPopup = true;
    },

    createNew(action = true) {
      this.creatingRole = false;
      Object.assign(this.formerrors, { msg: "" });
      this.edit = false;
      this.newform = { name: "", category: "user_roles" };
      this.addPopup = action;
    },

    deleteConform(item) {
      this.selectedItem = item;
      this.approveConformpopUp = true;
      this.edit = false;
    },

    getList(callFromSerch = false) {
      this.callFromSerch = callFromSerch;
      if (this.callFromSerch) {
        this.list = [];
      }
      this.updateLoading(true);

      let matcher = {
        searchString: this.searchtxt,
        statusIds: this.final_selected_statusids,
        createdDateRange: [],
      };
      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        matcher["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"],
        ];
      }

      let query = {};
      query["page"] = this.page;
      query["perpage"] = this.perpage;
      query["matcher"] = matcher;
      query["category"] = "user_roles";

      query["sorting"] = this.sortKey;

      this.$store
        .dispatch("getMasterData", query)
        .then((response) => {
          this.list = response.list;

          this.updateLoading(false);
          this.totalpages = Math.ceil(response.totalCount / this.perpage);
          //alert(this.perpage);
        })
        .catch(() => {
          this.list = [];
          this.updateLoading(false);
        });
    },
    updateMasetrRole() {
      //mDataId
      //alert(JSON.stringify(this.selectedItem));
      Object.assign(this.formerrors, {
        msg: "",
      });
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.creatingRole = true;
          let postData = this.newform;
          postData["name"] = this.newform["name"].trim();
          postData = Object.assign(postData, {
            _id: this.selectedItem["_id"],
            mDataId: this.selectedItem["id"],
          });
          this.$store
            .dispatch("updateMasetrRole", postData)
            .then((response) => {
              this.creatingRole = false;
              this.showToster({ message: response.message, isError: false });
              this.getList();
              this.addPopup = false;
              this.edit = false;
            })
            .catch((er) => {
              this.creatingRole = false;
              //this.showToster({message:er,isError:true});
              Object.assign(this.formerrors, {
                msg: er,
              });
              //this.showToster({message:"Somthin went wrong..!",isError:true});
            });
        }
      });
    },
    createformandLetter() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.creatingRole = true;
          let postData = this.newform;
          postData["name"] = this.newform["name"].trim();
          this.$store
            .dispatch("createMasterNewRole", postData)
            .then((response) => {
              this.creatingRole = false;
              this.showToster({ message: response.message, isError: false });
              this.getList();
              this.addPopup = false;
            })
            .catch((error) => {
              this.creatingRole = false;
              Object.assign(this.formerrors, {
                msg: error,
              });
            });
        }
      });
    },

    get_statusids() {
      const item = {
        page: 1,
        perpage: 10000,
        category: "form_letter_status",
      };

      this.$store.dispatch("getMasterData", item).then((response) => {
        this.all_statusids = response.list;
        // alert(JSON.stringify(response.list))
      });
    },

    set_filter: function () {
      this.$refs["filter_menu"].dropdownVisible = false;
      this.final_selected_statusids = [];
      if (this.selected_statusids.length > 0) {
        this.final_selected_statusids = [];
        for (let ind = 0; ind < this.selected_statusids.length; ind++) {
          let current_index = this.selected_statusids[ind];
          this.final_selected_statusids.push(current_index["id"]);
        }
      }

      this.final_selected_typesids = [];
      if (this.selected_typeids.length > 0) {
        this.final_selected_typesids = [];
        for (let ind = 0; ind < this.selected_typeids.length; ind++) {
          let current_index = this.selected_typeids[ind];
          this.final_selected_typesids.push(current_index["id"]);
        }
      }

      // alert(this.final_selected_typesids)

      this.getList(true);
    },
    clear_filter: function () {
      this.searchtxt = "";
      this.$refs["filter_menu"].dropdownVisible = false;
      this.selected_statusids = [];
      this.final_selected_statusids = [];
      this.final_selected_typesids = [];
      this.selected_typeids = [];

      this.date = "";
      this.date_range = [];
      this.selected_createdDateRange["startDate"] = "";
      this.selected_createdDateRange["endDate"] = "";
      this.getList();
    },
    pageNate(pageNum) {
      this.page = pageNum;
      this.getList();
    },

    deleteformandLetter() {
      let post_data = { formAndLetterId: this.selectedItem["_id"] };
      this.$store
        .dispatch("deleteformandLetter", post_data)
        .then((response) => {
          this.approveConformpopUp = false;
          this.showToster({ message: response.message, isError: false });
          this.getList();
          this.edit = false;
        })
        .catch((er) => {
          this.showToster({ message: er, isError: true });
        });
    },
  },
  mounted() {
    let loginRoleId = this.getUserRoleId;
          this.allowed_roles = [2,3,4, 5, 6, 7, 8, 9, 10, 11,12,13,14];

    if (loginRoleId == 3) {
      this.allowed_roles = [4, 5, 6, 7, 8, 9, 10, 11,12, 13,14];
       if(this.getTenantTypeId ==1){
        this.allowed_roles = [4, 5, 6, 7, 8, 9, 10, 11,13,14];
       }
    }
    if (loginRoleId == 4) {
      this.allowed_roles = [5, 6, 7, 8, 9, 10, 11, 12,13,14];
      if(this.getTenantTypeId ==1){
        this.allowed_roles = [5, 6, 7, 8, 9, 10, 11,13,14];
      }
    }
    if (this.$route.name != "basic-settings") {
      this.$store.dispatch("updateSidebarWidth", "extended");
    }
    //

    // this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
    this.selected_statusids = [];
    this.final_selected_statusids = [];
    this.seleted_states = [];
    this.final_selected_states = [];
    (this.sortKeys = {
      name: 1,
      type: 1,
      createdOn: -1,
      updatedOn: 1,
    }),
      (this.sortKey = { path: "createdOn", order: -1 });

    //this.get_statusids();
    this.getList();
  },
};
</script>
